import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { RowPromotion } from "./RowsTablePromotions";
import { Box, TablePagination } from "@mui/material";
import PromotionModal from "../ModalPromotion";
import ModalDetailsPromotions from "../ModalDetailsPromotion";
import ModalDeletePromotion from "../ModalDeletePromotion";

export default function TablePromotions({ rows = [], setLoading, type }) {
  const [page, setPage] = React.useState(0);
  const [selectedPromotions, setSelectedPromotions] = React.useState(null);
  const [showModalDetailsPromotion, setShowModalDetailsPromotion] =
    React.useState(false);
  const [showModalEditPromotion, setShowModalEditPromotion] =
    React.useState(false);
  const [showModalDeletePromotion, setShowModalDeletePromotion] =
    React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows = React.useMemo(() => {
    if (!rows || rows.length === 0) return [];

    return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [page, rowsPerPage, rows]);
  return (
    <>
      <PromotionModal
        open={showModalEditPromotion}
        promotion={selectedPromotions}
        setLoading={setLoading}
        setOpen={setShowModalEditPromotion}
      />
      <ModalDetailsPromotions
        open={showModalDetailsPromotion}
        setOpen={setShowModalDetailsPromotion}
        promotionData={selectedPromotions}
      />
      <ModalDeletePromotion
        open={showModalDeletePromotion}
        promotionData={selectedPromotions}
        setOpen={setShowModalDeletePromotion}
        setLoading={setLoading}
      />
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>Establecimiento</TableCell>
                  <TableCell align="center">Descuento</TableCell>
                  <TableCell align="center">Descripción</TableCell>
                  <TableCell align="center">Estatus</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRows.map((row) => {
                  return (
                    <RowPromotion
                      key={row._id}
                      row={row}
                      setSelectedPromotions={setSelectedPromotions}
                      setShowModalEditPromotion={setShowModalEditPromotion}
                      setShowModalDetailsPromotion={
                        setShowModalDetailsPromotion
                      }
                      setShowModalDeletePromotion={setShowModalDeletePromotion}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
}
